import { Component, OnInit } from '@angular/core';
import { ModalService } from '@purespectrum1/ui';
import { AuthService } from '../../../auth/auth.service';
import { MultiBuyerCmpAuth } from './../../../auth/auth.interface';
import { MultiBuyerModalComponent } from './../../../create-surveys/multi-buyer-modal/multi-buyer-modal.component';

@Component({
  selector: 'ps-multi-buyer-header',
  templateUrl: './multi-buyer-header.component.html',
  styleUrls: ['./multi-buyer-header.component.css'],
})
export class MultiBuyerHeaderComponent implements OnInit {
  public multiBuyer?: MultiBuyerCmpAuth;
  public cmpId?: number;

  constructor(
    private _authService: AuthService,
    private _modal: ModalService
  ) {}

  ngOnInit(): void {
    this._authService.selectedMultiBuyerCompany$.subscribe(() => {
      this.multiBuyer = this._authService.selectedMultiBuyerCompany;
    });
  }

  selectMultiBuyer() {
    this._modal.open(MultiBuyerModalComponent, {
      data: { cmpId: this.multiBuyer?.parentCompany },
    });
  }
}
